// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Self-Test — Mobile-first, Kid-friendly ===== */

.SelfTest {
    max-width: 600px;
    margin: 0 auto;
    padding: 72px 16px 32px;
    min-height: 100vh;
}

.SelfTest .pageTitle {
    font-size: 22px;
    font-weight: 700;
    color: var(--text-primary);
    margin: 0 0 16px;
    text-align: center;
}

/* ─── Card ─── */
.st-card {
    background: var(--bg-card);
    border: 2px solid var(--border-secondary);
    border-radius: 20px;
    padding: 20px 16px;
}

.st-description {
    color: var(--text-secondary);
    font-size: 15px;
    line-height: 1.5;
    margin: 0 0 16px;
    text-align: center;
}

.st-section-title {
    font-size: 16px;
    font-weight: 600;
    color: var(--text-primary);
    margin: 0 0 12px;
    text-align: center;
}

/* ─── Last Results (progress reference on intro) ─── */
.st-last-results {
    background: var(--bg-card);
    border: 2px solid var(--border-secondary);
    border-radius: 20px;
    padding: 16px;
    margin-bottom: 16px;
}

.st-last-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
    gap: 10px;
}

.st-last-item {
    text-align: center;
    padding: 12px 8px;
    background: var(--bg-secondary);
    border-radius: 14px;
    border: 1px solid var(--border-primary);
}

.st-last-eye {
    font-size: 12px;
    font-weight: 600;
    color: var(--text-muted);
    margin-bottom: 4px;
    text-transform: uppercase;
    letter-spacing: 0.04em;
}

.st-last-snellen {
    font-size: 22px;
    font-weight: 700;
    color: var(--text-primary);
    margin-bottom: 4px;
}

.st-last-badge {
    font-size: 20px;
    margin-bottom: 4px;
}

.st-last-date {
    font-size: 11px;
    color: var(--text-muted);
}

/* ─── Trend indicators ─── */
.st-trend {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    font-weight: 600;
    padding: 2px 8px;
    border-radius: 8px;
}

.st-trend-label {
    font-size: 11px;
}

.trend-up {
    color: #2ecc71;
    background: rgba(46, 204, 113, 0.12);
}

.trend-stable {
    color: var(--accent-primary);
    background: rgba(74, 144, 226, 0.12);
}

.trend-down {
    color: #e74c3c;
    background: rgba(231, 76, 60, 0.12);
}

/* ─── Disclaimer (simplified) ─── */
.st-disclaimer {
    font-size: 12px;
    color: var(--text-muted);
    text-align: center;
    margin-top: 14px;
    line-height: 1.4;
    padding: 0 8px;
}

/* ─── Buttons ─── */
.st-actions {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 8px;
}

.st-btn {
    display: block;
    width: 100%;
    padding: 14px 20px;
    border-radius: 50px;
    font-size: 16px;
    font-weight: 600;
    border: 2px solid transparent;
    cursor: pointer;
    transition: transform 0.15s, box-shadow 0.15s;
    text-align: center;
    -webkit-tap-highlight-color: transparent;
}

.st-btn:active {
    transform: scale(0.97);
}

.st-btn-large {
    padding: 18px 24px;
    font-size: 18px;
}

.st-btn-primary {
    background: var(--accent-primary);
    color: #fff;
}

.st-btn-primary:active {
    box-shadow: 0 4px 12px rgba(74, 144, 226, 0.4);
}

.st-btn-secondary {
    background: var(--bg-secondary);
    color: var(--text-primary);
    border-color: var(--border-secondary);
}

.st-btn-ghost {
    background: transparent;
    color: var(--text-muted);
    padding: 10px;
    font-size: 14px;
}

.st-btn-option {
    background: var(--bg-secondary);
    color: var(--text-primary);
    border-color: var(--border-secondary);
}

.st-btn-option.selected {
    border-color: var(--accent-primary);
    background: rgba(74, 144, 226, 0.1);
}

/* ─── Calibration ─── */
.st-calibration-area {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 0;
    min-height: 160px;
    user-select: none;
}

.st-credit-card {
    background: linear-gradient(135deg, #3a7bd5, #2c5aa0);
    border-radius: 10px;
    position: relative;
    cursor: ew-resize;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
    touch-action: none;
}

.st-card-inner {
    padding: 10px 14px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.st-card-chip {
    width: 30px;
    height: 22px;
    background: linear-gradient(135deg, #d4af37, #f2d272);
    border-radius: 3px;
}

.st-card-label {
    color: rgba(255, 255, 255, 0.85);
    font-size: 10px;
    font-weight: 600;
}

.st-card-size {
    color: rgba(255, 255, 255, 0.5);
    font-size: 9px;
}

.st-drag-handle {
    position: absolute;
    right: -14px;
    top: 50%;
    transform: translateY(-50%);
    width: 28px;
    height: 28px;
    background: var(--accent-primary);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 16px;
    cursor: ew-resize;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}

.st-slider-row {
    padding: 0 8px;
    margin-bottom: 16px;
}

.st-slider {
    width: 100%;
    height: 8px;
    -webkit-appearance: none;
    appearance: none;
    background: var(--border-secondary);
    border-radius: 4px;
    outline: none;
}

.st-slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: var(--accent-primary);
    cursor: pointer;
}

.st-slider::-moz-range-thumb {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: var(--accent-primary);
    border: none;
    cursor: pointer;
}

/* ─── Distance pick (inside calibration) ─── */
.st-distance-pick {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid var(--border-secondary);
}

.st-distance-options {
    display: flex;
    gap: 8px;
    margin-bottom: 16px;
}

.st-distance-options .st-btn-option {
    flex: 1;
    padding: 10px 8px;
    font-size: 13px;
    border-radius: 12px;
}

.st-distance-info {
    text-align: center;
    font-size: 13px;
    color: var(--text-muted);
    background: var(--bg-secondary);
    border-radius: 12px;
    padding: 10px;
    margin-bottom: 8px;
}

/* ─── Eye selection ─── */
.st-eye-buttons {
    display: flex;
    gap: 10px;
    margin-bottom: 12px;
}

.st-eye-btn {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    padding: 20px 8px;
    background: var(--bg-secondary);
    border: 2px solid var(--border-secondary);
    border-radius: 16px;
    cursor: pointer;
    transition: transform 0.15s, border-color 0.15s;
    -webkit-tap-highlight-color: transparent;
}

.st-eye-btn:active {
    transform: scale(0.95);
    border-color: var(--accent-primary);
}

.st-eye-icon {
    font-size: 32px;
}

.st-eye-label {
    font-size: 13px;
    font-weight: 600;
    color: var(--text-primary);
}

.st-hint {
    font-size: 13px;
    color: var(--text-muted);
    text-align: center;
    margin: 0 0 8px;
}

/* ─── Test screen ─── */
.st-test {
    text-align: center;
}

.st-test-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.st-test-eye {
    font-size: 13px;
    font-weight: 600;
    color: var(--accent-primary);
    background: var(--bg-card);
    border: 1px solid var(--border-secondary);
    padding: 5px 12px;
    border-radius: 16px;
}

.st-test-progress {
    font-size: 13px;
    color: var(--text-muted);
    font-weight: 600;
}

.st-progress-bar {
    width: 100%;
    height: 4px;
    background: var(--border-secondary);
    border-radius: 2px;
    margin-bottom: 20px;
    overflow: hidden;
}

.st-progress-fill {
    height: 100%;
    background: var(--accent-primary);
    border-radius: 2px;
    transition: width 0.3s ease;
}

.st-optotype-area {
    background: var(--bg-card);
    border: 2px solid var(--border-secondary);
    border-radius: 20px;
    padding: 32px 16px;
    margin-bottom: 20px;
    min-height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.st-optotypes {
    font-family: 'Courier New', Courier, monospace;
    font-weight: 700;
    color: var(--text-primary);
    letter-spacing: 0.12em;
    line-height: 1.2;
    text-align: center;
}

.st-question {
    font-size: 16px;
    color: var(--text-secondary);
    margin-bottom: 16px;
}

/* ─── Answer buttons — ALWAYS side-by-side, big touch targets ─── */
.st-test-buttons {
    display: flex;
    gap: 12px;
}

.st-answer-btn {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    padding: 20px 12px;
    border-radius: 16px;
    border: none;
    cursor: pointer;
    font-size: 15px;
    font-weight: 600;
    color: #fff;
    transition: transform 0.1s;
    -webkit-tap-highlight-color: transparent;
    min-height: 70px;
}

.st-answer-btn:active {
    transform: scale(0.95);
}

.st-answer-icon {
    font-size: 24px;
}

.st-answer-yes {
    background: #2ecc71;
}

.st-answer-yes:active {
    background: #27ae60;
}

.st-answer-no {
    background: #e74c3c;
}

.st-answer-no:active {
    background: #c0392b;
}

/* ─── Results ─── */
.st-result-eye-label {
    text-align: center;
    font-size: 13px;
    font-weight: 600;
    color: var(--accent-primary);
    margin-bottom: 12px;
    text-transform: uppercase;
    letter-spacing: 0.04em;
}

.st-result-big {
    text-align: center;
    margin-bottom: 12px;
}

.st-result-big-emoji {
    display: block;
    font-size: 40px;
    margin-bottom: 4px;
}

.st-result-big-snellen {
    font-size: 36px;
    font-weight: 700;
    color: var(--text-primary);
}

.st-acuity-badge {
    text-align: center;
    padding: 10px 16px;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 12px;
}

.st-acuity-excellent {
    background: rgba(46, 204, 113, 0.15);
    color: #2ecc71;
    border: 1px solid rgba(46, 204, 113, 0.3);
}

.st-acuity-normal {
    background: rgba(52, 152, 219, 0.15);
    color: #3498db;
    border: 1px solid rgba(52, 152, 219, 0.3);
}

.st-acuity-near_normal {
    background: rgba(241, 196, 15, 0.15);
    color: #f1c40f;
    border: 1px solid rgba(241, 196, 15, 0.3);
}

.st-acuity-mild_impairment {
    background: rgba(230, 126, 34, 0.15);
    color: #e67e22;
    border: 1px solid rgba(230, 126, 34, 0.3);
}

.st-acuity-moderate {
    background: rgba(231, 76, 60, 0.15);
    color: #e74c3c;
    border: 1px solid rgba(231, 76, 60, 0.3);
}

.st-acuity-significant {
    background: rgba(155, 89, 182, 0.15);
    color: #9b59b6;
    border: 1px solid rgba(155, 89, 182, 0.3);
}

.st-result-details {
    display: flex;
    gap: 10px;
    margin-bottom: 8px;
}

.st-result-detail {
    flex: 1;
    text-align: center;
    background: var(--bg-secondary);
    border-radius: 12px;
    padding: 10px 8px;
}

.st-detail-value {
    display: block;
    font-size: 18px;
    font-weight: 700;
    color: var(--text-primary);
}

.st-detail-label {
    font-size: 11px;
    color: var(--text-muted);
}

/* ─── History ─── */
.st-empty {
    text-align: center;
    color: var(--text-muted);
    font-style: italic;
    padding: 24px;
}

.st-history-group {
    margin-bottom: 20px;
}

.st-history-eye-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    padding-bottom: 6px;
    border-bottom: 1px solid var(--border-secondary);
}

.st-history-eye {
    font-size: 15px;
    font-weight: 600;
    color: var(--text-primary);
    margin: 0;
}

.st-history-table {
    display: flex;
    flex-direction: column;
    gap: 1px;
}

.st-history-header,
.st-history-row {
    display: grid;
    grid-template-columns: 1.4fr 1fr 0.8fr;
    gap: 6px;
    padding: 7px 10px;
    align-items: center;
}

.st-history-header {
    font-size: 11px;
    font-weight: 600;
    color: var(--text-muted);
    text-transform: uppercase;
    letter-spacing: 0.03em;
}

.st-history-row {
    font-size: 14px;
    color: var(--text-secondary);
    border-radius: 8px;
}

.st-history-row:nth-child(even) {
    background: var(--bg-secondary);
}

.st-history-snellen {
    font-weight: 600;
    color: var(--text-primary);
}

/* ─── Desktop enhancements ─── */
@media (min-width: 769px) {
    .SelfTest {
        padding-top: 80px;
    }

    .st-btn:hover {
        transform: translateY(-2px);
    }

    .st-btn-primary:hover {
        box-shadow: 0 6px 16px rgba(74, 144, 226, 0.4);
    }

    .st-eye-btn:hover {
        border-color: var(--accent-primary);
        transform: translateY(-2px);
    }

    .st-answer-btn:hover {
        transform: translateY(-2px);
    }

    .st-answer-yes:hover {
        box-shadow: 0 4px 12px rgba(46, 204, 113, 0.4);
    }

    .st-answer-no:hover {
        box-shadow: 0 4px 12px rgba(231, 76, 60, 0.4);
    }

    .st-credit-card:hover {
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);
    }

    .st-last-item:hover {
        transform: translateY(-2px);
        transition: transform 0.15s;
    }

    .st-history-row:hover {
        background: var(--bg-secondary);
    }
}

/* ─── Small mobile ─── */
@media (max-width: 380px) {
    .SelfTest {
        padding: 60px 10px 24px;
    }

    .st-card {
        padding: 16px 12px;
    }

    .st-eye-buttons {
        gap: 6px;
    }

    .st-eye-btn {
        padding: 14px 6px;
    }

    .st-eye-icon {
        font-size: 26px;
    }

    .st-eye-label {
        font-size: 11px;
    }

    .st-answer-btn {
        padding: 16px 8px;
        min-height: 60px;
    }

    .st-result-big-snellen {
        font-size: 28px;
    }

    .st-distance-options {
        flex-direction: column;
    }
}
`, "",{"version":3,"sources":["webpack://./src/css/SelfTest.css"],"names":[],"mappings":"AAAA,uDAAuD;;AAEvD;IACI,gBAAgB;IAChB,cAAc;IACd,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,iBAAiB;AACjB;IACI,0BAA0B;IAC1B,yCAAyC;IACzC,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,uDAAuD;AACvD;IACI,0BAA0B;IAC1B,yCAAyC;IACzC,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,+BAA+B;IAC/B,mBAAmB;IACnB,uCAAuC;AAC3C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,wBAAwB;AAC5B;;AAEA,6BAA6B;AAC7B;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,oCAAoC;AACxC;;AAEA;IACI,4BAA4B;IAC5B,oCAAoC;AACxC;;AAEA;IACI,cAAc;IACd,mCAAmC;AACvC;;AAEA,oCAAoC;AACpC;IACI,eAAe;IACf,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,eAAe;IACf,6CAA6C;IAC7C,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,iCAAiC;IACjC,WAAW;AACf;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,+BAA+B;IAC/B,0BAA0B;IAC1B,qCAAqC;AACzC;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;IACxB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,0BAA0B;IAC1B,qCAAqC;AACzC;;AAEA;IACI,mCAAmC;IACnC,mCAAmC;AACvC;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,qDAAqD;IACrD,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,yCAAyC;IACzC,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qDAAqD;IACrD,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,iCAAiC;IACjC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,wCAAwC;AAC5C;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,wBAAwB;IACxB,gBAAgB;IAChB,mCAAmC;IACnC,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iCAAiC;IACjC,YAAY;IACZ,eAAe;AACnB;;AAEA,+CAA+C;AAC/C;IACI,gBAAgB;IAChB,iBAAiB;IACjB,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,iBAAiB;IACjB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,wBAAwB;IACxB,+BAA+B;IAC/B,mBAAmB;IACnB,aAAa;IACb,kBAAkB;AACtB;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,+BAA+B;IAC/B,yCAAyC;IACzC,mBAAmB;IACnB,eAAe;IACf,+CAA+C;IAC/C,wCAAwC;AAC5C;;AAEA;IACI,sBAAsB;IACtB,mCAAmC;AACvC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;AACnB;;AAEA,wBAAwB;AACxB;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,0BAA0B;IAC1B,yCAAyC;IACzC,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,mCAAmC;IACnC,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,iCAAiC;IACjC,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;IAC1B,yCAAyC;IACzC,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,8CAA8C;IAC9C,gBAAgB;IAChB,0BAA0B;IAC1B,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA,oEAAoE;AACpE;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,0BAA0B;IAC1B,wCAAwC;IACxC,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,oBAAoB;AACpB;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,OAAO;IACP,kBAAkB;IAClB,+BAA+B;IAC/B,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,wBAAwB;AAC5B;;AAEA,oBAAoB;AACpB;IACI,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,gDAAgD;AACpD;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;;IAEI,aAAa;IACb,sCAAsC;IACtC,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA,iCAAiC;AACjC;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,8CAA8C;IAClD;;IAEA;QACI,mCAAmC;QACnC,2BAA2B;IAC/B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,8CAA8C;IAClD;;IAEA;QACI,6CAA6C;IACjD;;IAEA;QACI,yCAAyC;IAC7C;;IAEA;QACI,2BAA2B;QAC3B,2BAA2B;IAC/B;;IAEA;QACI,+BAA+B;IACnC;AACJ;;AAEA,yBAAyB;AACzB;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;AACJ","sourcesContent":["/* ===== Self-Test — Mobile-first, Kid-friendly ===== */\n\n.SelfTest {\n    max-width: 600px;\n    margin: 0 auto;\n    padding: 72px 16px 32px;\n    min-height: 100vh;\n}\n\n.SelfTest .pageTitle {\n    font-size: 22px;\n    font-weight: 700;\n    color: var(--text-primary);\n    margin: 0 0 16px;\n    text-align: center;\n}\n\n/* ─── Card ─── */\n.st-card {\n    background: var(--bg-card);\n    border: 2px solid var(--border-secondary);\n    border-radius: 20px;\n    padding: 20px 16px;\n}\n\n.st-description {\n    color: var(--text-secondary);\n    font-size: 15px;\n    line-height: 1.5;\n    margin: 0 0 16px;\n    text-align: center;\n}\n\n.st-section-title {\n    font-size: 16px;\n    font-weight: 600;\n    color: var(--text-primary);\n    margin: 0 0 12px;\n    text-align: center;\n}\n\n/* ─── Last Results (progress reference on intro) ─── */\n.st-last-results {\n    background: var(--bg-card);\n    border: 2px solid var(--border-secondary);\n    border-radius: 20px;\n    padding: 16px;\n    margin-bottom: 16px;\n}\n\n.st-last-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));\n    gap: 10px;\n}\n\n.st-last-item {\n    text-align: center;\n    padding: 12px 8px;\n    background: var(--bg-secondary);\n    border-radius: 14px;\n    border: 1px solid var(--border-primary);\n}\n\n.st-last-eye {\n    font-size: 12px;\n    font-weight: 600;\n    color: var(--text-muted);\n    margin-bottom: 4px;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n}\n\n.st-last-snellen {\n    font-size: 22px;\n    font-weight: 700;\n    color: var(--text-primary);\n    margin-bottom: 4px;\n}\n\n.st-last-badge {\n    font-size: 20px;\n    margin-bottom: 4px;\n}\n\n.st-last-date {\n    font-size: 11px;\n    color: var(--text-muted);\n}\n\n/* ─── Trend indicators ─── */\n.st-trend {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 12px;\n    font-weight: 600;\n    padding: 2px 8px;\n    border-radius: 8px;\n}\n\n.st-trend-label {\n    font-size: 11px;\n}\n\n.trend-up {\n    color: #2ecc71;\n    background: rgba(46, 204, 113, 0.12);\n}\n\n.trend-stable {\n    color: var(--accent-primary);\n    background: rgba(74, 144, 226, 0.12);\n}\n\n.trend-down {\n    color: #e74c3c;\n    background: rgba(231, 76, 60, 0.12);\n}\n\n/* ─── Disclaimer (simplified) ─── */\n.st-disclaimer {\n    font-size: 12px;\n    color: var(--text-muted);\n    text-align: center;\n    margin-top: 14px;\n    line-height: 1.4;\n    padding: 0 8px;\n}\n\n/* ─── Buttons ─── */\n.st-actions {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    margin-top: 8px;\n}\n\n.st-btn {\n    display: block;\n    width: 100%;\n    padding: 14px 20px;\n    border-radius: 50px;\n    font-size: 16px;\n    font-weight: 600;\n    border: 2px solid transparent;\n    cursor: pointer;\n    transition: transform 0.15s, box-shadow 0.15s;\n    text-align: center;\n    -webkit-tap-highlight-color: transparent;\n}\n\n.st-btn:active {\n    transform: scale(0.97);\n}\n\n.st-btn-large {\n    padding: 18px 24px;\n    font-size: 18px;\n}\n\n.st-btn-primary {\n    background: var(--accent-primary);\n    color: #fff;\n}\n\n.st-btn-primary:active {\n    box-shadow: 0 4px 12px rgba(74, 144, 226, 0.4);\n}\n\n.st-btn-secondary {\n    background: var(--bg-secondary);\n    color: var(--text-primary);\n    border-color: var(--border-secondary);\n}\n\n.st-btn-ghost {\n    background: transparent;\n    color: var(--text-muted);\n    padding: 10px;\n    font-size: 14px;\n}\n\n.st-btn-option {\n    background: var(--bg-secondary);\n    color: var(--text-primary);\n    border-color: var(--border-secondary);\n}\n\n.st-btn-option.selected {\n    border-color: var(--accent-primary);\n    background: rgba(74, 144, 226, 0.1);\n}\n\n/* ─── Calibration ─── */\n.st-calibration-area {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 20px 0;\n    min-height: 160px;\n    user-select: none;\n}\n\n.st-credit-card {\n    background: linear-gradient(135deg, #3a7bd5, #2c5aa0);\n    border-radius: 10px;\n    position: relative;\n    cursor: ew-resize;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);\n    touch-action: none;\n}\n\n.st-card-inner {\n    padding: 10px 14px;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n.st-card-chip {\n    width: 30px;\n    height: 22px;\n    background: linear-gradient(135deg, #d4af37, #f2d272);\n    border-radius: 3px;\n}\n\n.st-card-label {\n    color: rgba(255, 255, 255, 0.85);\n    font-size: 10px;\n    font-weight: 600;\n}\n\n.st-card-size {\n    color: rgba(255, 255, 255, 0.5);\n    font-size: 9px;\n}\n\n.st-drag-handle {\n    position: absolute;\n    right: -14px;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 28px;\n    height: 28px;\n    background: var(--accent-primary);\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #fff;\n    font-size: 16px;\n    cursor: ew-resize;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);\n}\n\n.st-slider-row {\n    padding: 0 8px;\n    margin-bottom: 16px;\n}\n\n.st-slider {\n    width: 100%;\n    height: 8px;\n    -webkit-appearance: none;\n    appearance: none;\n    background: var(--border-secondary);\n    border-radius: 4px;\n    outline: none;\n}\n\n.st-slider::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    width: 28px;\n    height: 28px;\n    border-radius: 50%;\n    background: var(--accent-primary);\n    cursor: pointer;\n}\n\n.st-slider::-moz-range-thumb {\n    width: 28px;\n    height: 28px;\n    border-radius: 50%;\n    background: var(--accent-primary);\n    border: none;\n    cursor: pointer;\n}\n\n/* ─── Distance pick (inside calibration) ─── */\n.st-distance-pick {\n    margin-top: 16px;\n    padding-top: 16px;\n    border-top: 1px solid var(--border-secondary);\n}\n\n.st-distance-options {\n    display: flex;\n    gap: 8px;\n    margin-bottom: 16px;\n}\n\n.st-distance-options .st-btn-option {\n    flex: 1;\n    padding: 10px 8px;\n    font-size: 13px;\n    border-radius: 12px;\n}\n\n.st-distance-info {\n    text-align: center;\n    font-size: 13px;\n    color: var(--text-muted);\n    background: var(--bg-secondary);\n    border-radius: 12px;\n    padding: 10px;\n    margin-bottom: 8px;\n}\n\n/* ─── Eye selection ─── */\n.st-eye-buttons {\n    display: flex;\n    gap: 10px;\n    margin-bottom: 12px;\n}\n\n.st-eye-btn {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 6px;\n    padding: 20px 8px;\n    background: var(--bg-secondary);\n    border: 2px solid var(--border-secondary);\n    border-radius: 16px;\n    cursor: pointer;\n    transition: transform 0.15s, border-color 0.15s;\n    -webkit-tap-highlight-color: transparent;\n}\n\n.st-eye-btn:active {\n    transform: scale(0.95);\n    border-color: var(--accent-primary);\n}\n\n.st-eye-icon {\n    font-size: 32px;\n}\n\n.st-eye-label {\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--text-primary);\n}\n\n.st-hint {\n    font-size: 13px;\n    color: var(--text-muted);\n    text-align: center;\n    margin: 0 0 8px;\n}\n\n/* ─── Test screen ─── */\n.st-test {\n    text-align: center;\n}\n\n.st-test-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 8px;\n}\n\n.st-test-eye {\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--accent-primary);\n    background: var(--bg-card);\n    border: 1px solid var(--border-secondary);\n    padding: 5px 12px;\n    border-radius: 16px;\n}\n\n.st-test-progress {\n    font-size: 13px;\n    color: var(--text-muted);\n    font-weight: 600;\n}\n\n.st-progress-bar {\n    width: 100%;\n    height: 4px;\n    background: var(--border-secondary);\n    border-radius: 2px;\n    margin-bottom: 20px;\n    overflow: hidden;\n}\n\n.st-progress-fill {\n    height: 100%;\n    background: var(--accent-primary);\n    border-radius: 2px;\n    transition: width 0.3s ease;\n}\n\n.st-optotype-area {\n    background: var(--bg-card);\n    border: 2px solid var(--border-secondary);\n    border-radius: 20px;\n    padding: 32px 16px;\n    margin-bottom: 20px;\n    min-height: 120px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.st-optotypes {\n    font-family: 'Courier New', Courier, monospace;\n    font-weight: 700;\n    color: var(--text-primary);\n    letter-spacing: 0.12em;\n    line-height: 1.2;\n    text-align: center;\n}\n\n.st-question {\n    font-size: 16px;\n    color: var(--text-secondary);\n    margin-bottom: 16px;\n}\n\n/* ─── Answer buttons — ALWAYS side-by-side, big touch targets ─── */\n.st-test-buttons {\n    display: flex;\n    gap: 12px;\n}\n\n.st-answer-btn {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 4px;\n    padding: 20px 12px;\n    border-radius: 16px;\n    border: none;\n    cursor: pointer;\n    font-size: 15px;\n    font-weight: 600;\n    color: #fff;\n    transition: transform 0.1s;\n    -webkit-tap-highlight-color: transparent;\n    min-height: 70px;\n}\n\n.st-answer-btn:active {\n    transform: scale(0.95);\n}\n\n.st-answer-icon {\n    font-size: 24px;\n}\n\n.st-answer-yes {\n    background: #2ecc71;\n}\n\n.st-answer-yes:active {\n    background: #27ae60;\n}\n\n.st-answer-no {\n    background: #e74c3c;\n}\n\n.st-answer-no:active {\n    background: #c0392b;\n}\n\n/* ─── Results ─── */\n.st-result-eye-label {\n    text-align: center;\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--accent-primary);\n    margin-bottom: 12px;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n}\n\n.st-result-big {\n    text-align: center;\n    margin-bottom: 12px;\n}\n\n.st-result-big-emoji {\n    display: block;\n    font-size: 40px;\n    margin-bottom: 4px;\n}\n\n.st-result-big-snellen {\n    font-size: 36px;\n    font-weight: 700;\n    color: var(--text-primary);\n}\n\n.st-acuity-badge {\n    text-align: center;\n    padding: 10px 16px;\n    border-radius: 12px;\n    font-size: 14px;\n    font-weight: 600;\n    margin-bottom: 12px;\n}\n\n.st-acuity-excellent {\n    background: rgba(46, 204, 113, 0.15);\n    color: #2ecc71;\n    border: 1px solid rgba(46, 204, 113, 0.3);\n}\n\n.st-acuity-normal {\n    background: rgba(52, 152, 219, 0.15);\n    color: #3498db;\n    border: 1px solid rgba(52, 152, 219, 0.3);\n}\n\n.st-acuity-near_normal {\n    background: rgba(241, 196, 15, 0.15);\n    color: #f1c40f;\n    border: 1px solid rgba(241, 196, 15, 0.3);\n}\n\n.st-acuity-mild_impairment {\n    background: rgba(230, 126, 34, 0.15);\n    color: #e67e22;\n    border: 1px solid rgba(230, 126, 34, 0.3);\n}\n\n.st-acuity-moderate {\n    background: rgba(231, 76, 60, 0.15);\n    color: #e74c3c;\n    border: 1px solid rgba(231, 76, 60, 0.3);\n}\n\n.st-acuity-significant {\n    background: rgba(155, 89, 182, 0.15);\n    color: #9b59b6;\n    border: 1px solid rgba(155, 89, 182, 0.3);\n}\n\n.st-result-details {\n    display: flex;\n    gap: 10px;\n    margin-bottom: 8px;\n}\n\n.st-result-detail {\n    flex: 1;\n    text-align: center;\n    background: var(--bg-secondary);\n    border-radius: 12px;\n    padding: 10px 8px;\n}\n\n.st-detail-value {\n    display: block;\n    font-size: 18px;\n    font-weight: 700;\n    color: var(--text-primary);\n}\n\n.st-detail-label {\n    font-size: 11px;\n    color: var(--text-muted);\n}\n\n/* ─── History ─── */\n.st-empty {\n    text-align: center;\n    color: var(--text-muted);\n    font-style: italic;\n    padding: 24px;\n}\n\n.st-history-group {\n    margin-bottom: 20px;\n}\n\n.st-history-eye-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 8px;\n    padding-bottom: 6px;\n    border-bottom: 1px solid var(--border-secondary);\n}\n\n.st-history-eye {\n    font-size: 15px;\n    font-weight: 600;\n    color: var(--text-primary);\n    margin: 0;\n}\n\n.st-history-table {\n    display: flex;\n    flex-direction: column;\n    gap: 1px;\n}\n\n.st-history-header,\n.st-history-row {\n    display: grid;\n    grid-template-columns: 1.4fr 1fr 0.8fr;\n    gap: 6px;\n    padding: 7px 10px;\n    align-items: center;\n}\n\n.st-history-header {\n    font-size: 11px;\n    font-weight: 600;\n    color: var(--text-muted);\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n}\n\n.st-history-row {\n    font-size: 14px;\n    color: var(--text-secondary);\n    border-radius: 8px;\n}\n\n.st-history-row:nth-child(even) {\n    background: var(--bg-secondary);\n}\n\n.st-history-snellen {\n    font-weight: 600;\n    color: var(--text-primary);\n}\n\n/* ─── Desktop enhancements ─── */\n@media (min-width: 769px) {\n    .SelfTest {\n        padding-top: 80px;\n    }\n\n    .st-btn:hover {\n        transform: translateY(-2px);\n    }\n\n    .st-btn-primary:hover {\n        box-shadow: 0 6px 16px rgba(74, 144, 226, 0.4);\n    }\n\n    .st-eye-btn:hover {\n        border-color: var(--accent-primary);\n        transform: translateY(-2px);\n    }\n\n    .st-answer-btn:hover {\n        transform: translateY(-2px);\n    }\n\n    .st-answer-yes:hover {\n        box-shadow: 0 4px 12px rgba(46, 204, 113, 0.4);\n    }\n\n    .st-answer-no:hover {\n        box-shadow: 0 4px 12px rgba(231, 76, 60, 0.4);\n    }\n\n    .st-credit-card:hover {\n        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);\n    }\n\n    .st-last-item:hover {\n        transform: translateY(-2px);\n        transition: transform 0.15s;\n    }\n\n    .st-history-row:hover {\n        background: var(--bg-secondary);\n    }\n}\n\n/* ─── Small mobile ─── */\n@media (max-width: 380px) {\n    .SelfTest {\n        padding: 60px 10px 24px;\n    }\n\n    .st-card {\n        padding: 16px 12px;\n    }\n\n    .st-eye-buttons {\n        gap: 6px;\n    }\n\n    .st-eye-btn {\n        padding: 14px 6px;\n    }\n\n    .st-eye-icon {\n        font-size: 26px;\n    }\n\n    .st-eye-label {\n        font-size: 11px;\n    }\n\n    .st-answer-btn {\n        padding: 16px 8px;\n        min-height: 60px;\n    }\n\n    .st-result-big-snellen {\n        font-size: 28px;\n    }\n\n    .st-distance-options {\n        flex-direction: column;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
